
export const NODE_ENV = 'production';
export const API_URL = 'https://api.lifesaver.fit';
export const VERSION = '2026-01-06T12:55:56.163Z';
